import { render, staticRenderFns } from "./DialogProfileKeywordSetting.vue?vue&type=template&id=4dff505c&scoped=true"
import script from "./DialogProfileKeywordSetting.vue?vue&type=script&lang=ts"
export * from "./DialogProfileKeywordSetting.vue?vue&type=script&lang=ts"
import style0 from "./DialogProfileKeywordSetting.vue?vue&type=style&index=0&id=4dff505c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dff505c",
  null
  
)

export default component.exports